import type { ReportUploadedFileDto } from "@/api/dtos";
import type { ReportUploadedFile } from "@/api/report/_models/ReportUpload";

/** DTO → domain for one raw export already in S3. */
export const toReportUploadedFileFromDto = (dto: ReportUploadedFileDto): ReportUploadedFile => {
  return {
    id: dto.id,
    key: dto.key,
    filename: dto.filename,
    size: dto.size,
    uploadedAt: dto.uploadedAt,
  };
};
